import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import DateTimeInput from './DateTimeInput';

const adjustDate = (hours, minutes, seconds) => {
	const date = new Date();
	date.setHours(hours || 0);
	date.setMinutes(minutes || 0);
	date.setSeconds(seconds || 0);
	return date;
}

const TimeInput = ({ name, label, isReadonly, validators, startTime = 8, endTime = 21, step = 5, onChange, horizontal, required, ...props }) => {
	const min = adjustDate(startTime);
	const max = adjustDate(endTime);
	const format = 'HH:mm';
	return (
		<Field
			name={name}
			component={DateTimeInput}
			disabled={isReadonly}
			required={required}
			horizontal={horizontal}
			date={false}
			time={true}
			min={min}
			max={max}
			step={step}
			label={label}
			dateFormat={format}
			validate={validators}
			onChange={onChange}
			{...props}
		/>
	);
};
TimeInput.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string
};
export default TimeInput;